module.exports = __webpack_public_path__ + "static/media/M1.32c59651.jpg";